; !function (w) {
  var plugin = {
    /**
     * 公共请求方法
     * @param {*} url  请求链接 
     * @param {*} data  参数
     */
    ajax: function (url, data) {
      var api = '';
      // 根据域名区分环境
      if (window.Shopify.shop.indexOf('pro-') > -1) {
        // 沙盒环境
        api = 'https://community.topdon.com';
      } else {
        api = 'https://community.topdon.com';
      }
      // 判断是否有http 有我就不加上前面域名
      if (url.indexOf('http') < 0) {
        url = api + url;
      }
      data.store_id = 2;
      // 增加公共参数
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: url,
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(data),
          dataType: "json",
          crossDomain: true,
          success: function (res) {
            resolve(res)
          },
          error: err => {
            reject(err)
          }
        })
      })
    },
    /**
     * 注册接口
     * @param {*} 接口地址 
     * @param {*} data 参数
     */
    shopiyfRegister: function (url, data) {
      let that = this
      let result = data
      return new Promise((resolve, reject) => {
        that.ajax(url, data).then(res => {
          if (res.code == 1) {
            // 延时处理一下
            resolve(that.login(result));
          } else {
            reject(res)
          }
        })
      })
    },
    /**
     * 登录接口
     */
    login: function (result) {
      let loginUrl = '/account/login'
      var data = {
        'customer[email]': result.account,
        'customer[password]': result.password,
        form_type: 'customer_login',
        utf8: '✓'
      }
      return new Promise((resolve, reject) => {
        $.ajax({
          url: loginUrl,
          method: 'post',
          data: data,
          dataType: 'html',
          async: false,
          complete: function (res) {
            // JSON.parse()
            resolve(res.responseText)
          },
          error: err => {
            reject(err)
          }
        });
      });
    },
    isExistDate: function (dateStr) { // yyyy/mm/dd
      const dateObj = dateStr.split('-');

      //列出12個月，每月最大日期限制
      const limitInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      const theYear = parseInt(dateObj[0]);
      const theMonth = parseInt(dateObj[1]);
      const theDay = parseInt(dateObj[2]);
      const isLeap = new Date(theYear, 1, 29).getDate() === 29; // 是否為閏年?

      if (isLeap) { // 若為閏年，最大日期限制改為 29
        limitInMonth[1] = 29;
      }

      // 比對該日是否超過每個月份最大日期限制
      return theDay <= limitInMonth[theMonth - 1]
    },
    /**
     * 判断终端是否是手机
     * 成功 true
     */
    isMobile: function () {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      return Agents.some(function (item) {
        return userAgentInfo.indexOf(item) > 0
      });
    },
    /**
     * 格式化日期
     * yyyy-mm-dd HH:MM:SS
     */
    dateFormat: function (fmt, date) {
      let ret;
      let opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
    /**
     * 编码
     * @param {*} str 
     */
    base64Encode(str) {
      return window.atob(str);
    },
    /**
     * 解码 base64
     */
    base64Decode(str) {
      return window.btoa(str);
    },
    //获取url中"?"符后的字串 
    getQuerysString: function() {
      var url = location.search; 
      var theRequest = new Object(); 
      if (url.indexOf("?") != -1) { 
        var str = url.substr(1); 
        strs = str.split("&"); 
        for(var i = 0; i < strs.length; i ++) { 
        theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]); 
        } 
      } 
      return theRequest; 
    },
        getEaQuerysString: function () { //修复easter-activity查询参数乱拼的bug
          var url = decodeURIComponent(location.search);
          var theRequest = new Object();
          if (url.indexOf("?") != -1) {
            var index = url.lastIndexOf('?');
            var str = url.substr(index).substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1] || '');
            }
          }
          return theRequest;
        },
        getEaQuerysString: function () { //修复easter-activity查询参数乱拼的bug
          var url = decodeURIComponent(location.search);
          var theRequest = new Object();
          if (url.indexOf("?") != -1) {
            var index = url.lastIndexOf('?');
            var str = url.substr(index).substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1] || '');
            }
          }
          return theRequest;
        },
        // 设置cookie
        setCookie: function(cname, cvalue, exdays) {
          const d = new Date()
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
          const expires = 'expires=' + d.toGMTString()
          document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/'
        }
  }
  w.plugin = plugin;
}(window);